export const CustomsFinalizeSent =[
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-invoice-dollar",
        emit: "buttons:order:menu:createInvoice",
        key: "accept",
        text: "labels.order.create_invoice"
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-pdf",
        emit: "kooi:offer:menu:openpdf",
        key: "openpdf",
        text: 'labels.order.download_pdf',
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clone",
        emit: "kooi:menu:copy_to_new_kooi",
        key: "emit",
        text: "labels.clone.copy_to_new_kooi"
    },
];

export const CustomsMenus = {
    open: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clipboard-check",
            emit: "kooi:offer:menu:pdf_validation",
            key: "validatepdf",
            text: "labels.pdf.validation.pdf_validation",
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            key: "sendmail",
            text: "labels.order.send_email",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon_url: "/images/logos/mycroft-mc.png",
            emit: "kooi:menu:finalize",
            key: "finalize",
            text: "labels.order.finalize",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.offer.menus.reject"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clone",
            emit: "kooi:menu:copy_to_new_kooi",
            key: "emit",
            text: "labels.clone.copy_to_new_kooi"
        },
    ],
    outgoing: [
        {
            loading: false,
            key: "sendNow",
            text: "labels.invoice.menus.send_mail"
        },
        {
            loading: false,
            key: "abort",
            icon: "fas fa-plane-slash",
            text: "labels.invoice.menus.abort",
            emit: "kooi:mails:menu:abort",
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-invoice-dollar",
            emit: "buttons:order:menu:createInvoice",
            key: "accept",
            text: "labels.order.create_invoice"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon_url: "/images/logos/mycroft-mc.png",
            emit: "kooi:menu:finalize",
            key: "finalize",
            text: "labels.order.finalize",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clone",
            emit: "kooi:menu:copy_to_new_kooi",
            key: "emit",
            text: "labels.clone.copy_to_new_kooi"
        },
    ],
    finalize: CustomsFinalizeSent,
    sent: CustomsFinalizeSent,
    accepted: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "customs" || item.type == "customs")) != undefined) }
        }
    ]
};
